import Calendar from 'react-big-calendar'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import React, { Component } from 'react'
import {
  filter,
  sortBy,
  uniq,
  uniqBy,
  map,
  get,
  isNil,
  each,
  includes,
  some,
  isNull,
  isEmpty
} from 'lodash'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import {
  RemoteTable,
  BrowserStorage,
  FilterWrapper,
  FilterSelector,
  FilterSearch,
  FilterBar,
  Tabs,
  Tab,
  Popup,
  ButtonContainer,
  Button
} from 'camino-react'

import Event from './Event'
import EventModal from './EventModal'
import TimeGridHeader from './CustomComponents/TimeGridHeader'
import ResourceHeader from './CustomComponents/ResourceHeader'
import ResourcesBar from './CustomComponents/ResourcesBar'
import Legend from './CustomComponents/Legend'
import CustomEvent from './CustomComponents/CustomEvent'
import { handlers } from './handlers'
import {
  eventsFilterContainer,
  resourcesContainer,
  calendarDefaultsContainer,
  columns,
  filterOptions,
  ticketsTableTabs
} from './containers'

import LoadingSpinner from 'Components/LoadingSpinner'
import TicketTimesheetCreate from 'Components/Tickets/TicketTimesheets/TicketTimesheetCreate'
import EventWrapper from './CustomComponents/EventWrapper'
import TicketStatusExtraFields from './CustomComponents/TicketStatusExtraFields'

const moment = extendMoment(Moment)
const DispatcherCalendar = withDragAndDrop(Calendar)
const localizer = Calendar.momentLocalizer(moment)
const FilterTableHeaderComponent = ({
  tabs,
  initialFilterOptions,
  addFilter,
  filterText,
  searchFilter,
  searchText,
  filters,
  showSearch = true,
  triggerUpdate,
  reloadTicketsTable,
  afterReloadCallback,
  shouldAddQueueFilters,
  filtersToAdd
}) => {
  if (reloadTicketsTable) {
    triggerUpdate()
    afterReloadCallback()
  }

  if (shouldAddQueueFilters) {
    const filtersValues = map(filters, fil => fil.value)

    each(filter(filtersToAdd, filterToAdd => !includes(filtersValues, filterToAdd.value)), filterToAdd => addFilter(filterToAdd))
    afterReloadCallback()
  }

  return (
    <React.Fragment>
      {some(tabs) && (
        <Tabs>
          {map(tabs, tab => (
            <Tab key={tab.text} {...tab}>
              {tab.text}
            </Tab>
          ))}
        </Tabs>
      )}
      <FilterWrapper>
        <FilterSelector
          options={initialFilterOptions}
          addFilter={addFilter}
          text={filterText}
        />
        {showSearch && <FilterSearch filter={searchFilter} placeholder={searchText} />}
      </FilterWrapper>
      <FilterBar filters={filters} />
    </React.Fragment>
  )
}
class Dispatcher extends Component {
  constructor (props) {
    super(props)

    this.state = {
      ...this.props,
      minHour: new Date(0, 0, 0, 8, 0, 0),
      maxHour: new Date(0, 0, 0, 18, 30, 0),
      loadingTickets: true,
      timesheetOpen: false,
      reloadTicketsTable: false,
      shouldAddQueueFilters: false,
      filtersToAdd: [],
      timesheetEvent: {
        meta: {}
      }
    }
    this.handlers = handlers.bind(this)
  }

  componentDidMount () {
    handlers.getResourcesForSelect()
    handlers.getCalendarEvents()
  }

  render () {
    const {
      calendarDefaults,
      currentUser,
      events,
      newEvent,
      policies,
      processing,
      processingEvent,
      resources,
      showEvent,
      ticketsForSelect,
      minHour,
      maxHour,
      queues,
      statusNames,
      clients,
      regions,
      loadingTickets,
      filtersToAdd,
      priorities,
      timesheetOpen,
      timesheetEvent,
      ccOptions,
      timesheetTicket,
      statusesRootIds,
      users,
      reloadTicketsTable,
      shouldAddQueueFilters,
      displayStatusExtraFields,
      reopenOn,
      onHoldDescription,
      rootCause,
      preventiveAction,
      correctiveAction,
      selectedStatus,
      statusTicketId
    } = this.state

    const timesheet = {
      start_time: timesheetEvent.start,
      end_time: timesheetEvent.end,
      description: timesheetEvent.description,
      taskId: timesheetEvent.meta.id
    }

    const contextPriorities = handlers.prepareTicketContextMenuItems(priorities, 'priority')
    const contextStatuses = handlers.prepareTicketContextMenuItemsForStatus(statusNames, 'status')

    return (
      <div className="dispatcher">
        {processing && <LoadingSpinner withOverlay />}
        <div className="content-section__content">
          <Legend events={uniqBy(events, 'meta.klass_name')} />

          <div className="content-section__options">
            <h4 className="content-section__title">Resources</h4>
          </div>

          <ResourcesBar
            onChange={handlers.resourcesBar_onChange}
            options={sortBy(uniq(resources.resourceBar), resource => resource.label)}
            value={resources.resourceBarValues}
          />
        </div>
        <div className="content-section__content">
          <div className="calendar dispatcher__container">
            {newEvent && policies.dispatcher.create && (
              <EventModal
                onClose={handlers.dispatcher_newEvent_onClose}
                event={newEvent}
                onSubmitEvent={handlers.dispatcher_event_onSubmit}
                resourcesForSelect={filter(resources.resourceBar, resource => resource.type === 'user')}
                currentUser={currentUser}
                processingEvent={processingEvent}
                ticketsForSelect={ticketsForSelect}
                formSource="Dispatcher"
              />
            )}
            {(showEvent) && (showEvent.meta.taskable_type === 'Ticket') && policies.dispatcher.create && (
              <EventModal
                onClose={handlers.dispatcher_event_onClose}
                event={showEvent}
                onSubmitEvent={handlers.dispatcher_event_onSubmit}
                onDeleteEvent={handlers.dispatcher_event_onDelete}
                resourcesForSelect={filter(resources.resourceBar, resource => resource.type === 'user')}
                currentUser={currentUser}
                processingEvent={processingEvent}
                ticketsForSelect={ticketsForSelect}
                formSource="Dispatcher"
              />
            )}
            {(showEvent) && ((showEvent.meta.taskable_type !== 'Ticket') || !policies.dispatcher.create) && (
              <Event onClose={handlers.dispatcher_event_onClose} event={showEvent} />
            )}

            <DispatcherCalendar
              droppable
              key={new Date()}
              defaultDate={calendarDefaults.defaultDate}
              defaultView={calendarDefaults.currentView}
              events={events}
              onEventDrop={handlers.eventMove}
              onEventResize={handlers.eventMove}
              draggableAccessor={event => event.meta.taskable_type === 'Ticket' && policies.dispatcher.create}
              localizer={localizer}
              onNavigate={handlers.calendar_onNavigate}
              onSelectEvent={handlers.calendar_onSelectEvent}
              // onSelectSlot={handlers.calendar_onSelectSlot}
              onView={handlers.calendar_onView}
              onRangeChange={handlers.calendar_onRangeChange}
              popup
              step={15}
              resourceIdAccessor="resourceId"
              resourceTitleAccessor="resourceTitle"
              resourceOutlookAuthorizedAccessor="resourceOutlookAuthorized"
              resources={resources.dispatcher}
              scrollToTime={moment({ hour: 8 }).toDate()}
              selectable={policies.dispatcher.create}
              startAccessor={event => moment(event.start).toDate()}
              endAccessor={event => moment(event.end).toDate()}
              views={['month', 'week', 'day']}
              eventPropGetter={event => ({
                style: {
                  backgroundColor: event.meta.color,
                  borderColor: 'rgba(0, 0, 0, 0.1)',
                  textDecoration: includes(event.title, 'Canceled') ? 'line-through' : ''
                }
              })}
              slotPropGetter={(slot, resourceId) => ({
                onDrop: (event) => { handlers.createEventOnDrag(event, slot, resourceId); handlers.setEventsContainerPosition('absolute') },
                onDragOver: (event) => { handlers.highlightTimeSlot(event, 'rgba(0, 0, 0, 0.2)'); handlers.setEventsContainerPosition('unset') },
                onDragLeave: event => handlers.highlightTimeSlot(event, ''),
                className: handlers.highlightWorkingHours(slot, resourceId)
              })}
              min={minHour}
              max={maxHour}
              components={{
                timeGutterHeader: props => (<TimeGridHeader {...props} manageViewHours={action => handlers.manageViewHours(action)} />),
                resourceHeader: props => (<ResourceHeader resource={props.resource} />),
                event: props => (<CustomEvent {...props} />),
                eventWrapper: props => (
                  <EventWrapper
                    {...props}
                    {...this.state}
                    displayTimesheetEntry={(state, event) => handlers.displayTimesheetEntry(state, event)}
                  />
                )
              }}
            />
          </div>
        </div>
        <div style={{ marginTop: '15px' }}>
          <RemoteTable
            storage={{
              filters: new BrowserStorage('sessionStorage')
            }}
            tabs={ticketsTableTabs(map(currentUser.queues, queue => queue.id), currentUser.id)}
            defaultTabIndex={1}
            localStoragePrefix="DispatcherTable"
            remoteEndpoint="/api/dispatcher/tickets"
            transformRows={remoteRows => map(remoteRows, row => Object.assign(
              {},
              row,
              {
                id: row.id.value,
                age: moment(new Date()).diff(moment(row.created_at), 'days', true).toFixed(2),
                assignee_name: isNil(row.assignee_name) ? 'Not yet assigned' : row.assignee_name,
                href: null
              }
            ))}
            onRemoteData={({ rows }) => this.setState({ ticketsForSelect: rows })}
            filterOptions={filterOptions(queues, statusNames, clients, regions, users)}
            transformFilterOptions={() => filterOptions(queues, statusNames, clients, regions, users)}
            loading={loadingTickets}
            columns={columns(contextStatuses, contextPriorities)}
            transformColumns={() => columns(contextStatuses, contextPriorities)}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            defaultPageSize={25}
            getTrGroupProps={(state, rowInfo, column, instance) => ({
              draggable: true,
              onDragStart: () => this.setState({ draggedTicket: rowInfo.original }, () => handlers.setEventsContainerPosition('unset')),
              onDragEnd: () => handlers.setEventsContainerPosition('absolute')
            })}
            HeaderComponent={props => (
              <FilterTableHeaderComponent
                {...props}
                reloadTicketsTable={reloadTicketsTable}
                afterReloadCallback={handlers.afterReloadCallback}
                filtersToAdd={filtersToAdd}
                shouldAddQueueFilters={shouldAddQueueFilters}
              />
            )
            }
          />
        </div>

        <TicketStatusExtraFields
          {...{
            displayStatusExtraFields, selectedStatus, statusTicketId
          }}
          updateDispatcherState={value => this.setState(value)}
          updateTicketStatus={fields => handlers.updateTicketStatus(fields)}
        />

        {timesheetEvent && !isEmpty(timesheetTicket) && (
          <TicketTimesheetCreate
            open
            title="New Ticket Timesheet"
            url={`/api/tickets/${timesheetEvent.meta.taskable_id}/timesheets.json`}
            method="post"
            onClose={() => handlers.closeTimesheetForm()}
            modalOpen={timesheetOpen}
            ticketStatuses={statusNames}
            ticketId={timesheetEvent.meta.taskable_id}
            timesheet={timesheet}
            contactName={get(timesheetTicket, 'contact_name')}
            ccOptions={ccOptions}
            statusesRootIds={statusesRootIds}
            hasManagedServiceGroup={get(timesheetTicket, 'hasManagedServiceGroup')}
            defaultServiceGroupId={get(timesheetTicket, 'defaultServiceGroupId')}
            serviceGroups={get(timesheetTicket, 'serviceGroups', [])}
            reviewed={!isNull(get(timesheetTicket, 'reviewed_at'))}
            regionId={get(timesheetTicket, 'region_id')}
          />
        )}
      </div>
    )
  }
}

Dispatcher.defaultProps = {
  calendarDefaults: calendarDefaultsContainer,
  events: [],
  eventsEndpoint: '/api/dispatcher/events',
  eventsFilter: eventsFilterContainer,
  newEvent: null,
  resources: resourcesContainer,
  resourcesEndpoint: '/api/dispatcher/resources',
  showEvent: null,
  processing: false,
  processingEvent: false,
  alert: null
}

export default Dispatcher
